module.exports = __webpack_public_path__ + "face-dialogArr.2b3fabfb.png";